import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { FocusCSS, Focus } from '@fenderdigital/ui/utils/css';

export const Row = styled.li<{ isSelected?: boolean }>`
  margin-bottom: ${({ theme }): string => theme.spacing.md1};
  ${({ isSelected }): any => (isSelected ? FocusCSS : '')};

  ${Focus};
`;

export const Image = styled.img<{ type?: string }>`
  ${({ type }): FlattenSimpleInterpolation => {
    if (type === 'Artists') {
      return css`
        width: 3rem;
        height: 3rem;
        border-radius: 50%;
      `;
    }

    if (type === 'Collections') {
      return css`
        width: 10.438rem;
        height: 5.875rem;
        object-fit: cover;
      `
    }

    return css`
      max-width: 3.875rem;
      width: 100%;
      height: 3.875rem;
      border-radius: 0.25rem;
      object-fit: cover;
    `;
  }}
`;
